<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js'
	export default {
		name: '',
		components: {},
		props:{
			toseeUpdate: {
				type: Boolean,
				default: false
			},
			tableDataI:{
				type: Array,
				default: [],
			},
			tableDataII:{
				type: Array,
				default: [],
			},
			tableDataIII:{
				type: Array,
				default: [],
			},
			tableDataIV:{
				type: Array,
				default: [],
			},
			headobj: {
				type: Object,
				default: {},
			},
			choosecellCode:{
				type:String,
				default:""
			},
			type: {
				type: String,
				default: ""
			},
		},
		data: function() {
			return {
				headDataI: getdata().headDataI,
				headDataII: getdata().headDataII,
				headDataIII: getdata().headDataIII,
				headDataIV: getdata().headDataIV,
			};
		},
		created() {},
		methods: {
			inputblur(e){
			this.$emit("inputblur",e)
			},
			forhover(table,colum,index){
				this.$emit("forhover",table,colum,index)
			},
			zcsclick(e){
				this.$emit("zcsclick",e)
			},
		}
	};
</script>


<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SalesTaxReport/index.less');
</style>
